import React, { useEffect } from 'react'
import { ReactComponent as ProfileIcon} from '../../../images/icons/facebookColor.svg'
import $ from 'jquery'
import ApiUrl from '../../../configTools/apiUrl'

const Facebook = () => {
    /* global FB */
    window.fbAsyncInit = function() {
        FB.init({
            appId   : '766079861793524',
            oauth   : true,
            status  : true, // check login status
            cookie  : true, // enable cookies to allow the server to access the session
            xfbml   : true // parse XFBML
        });
    
    };
    function fb_login(){
        FB.login(function(response) {
            if (response.authResponse) {
                console.log('Welcome!  Fetching your information.... ');
                console.log(response); // dump complete info
                var access_token = response.authResponse.accessToken; //get access token
                console.log(access_token)
                fetch(ApiUrl.API_URL_OAuth+"/facebook", {//'http://localhost:5157/api/oauth/facebook',{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        token: access_token
                    })
                })
                .then(res=>res.json())
                .then(res=>{
                    console.log(res)
                    if(res.success){
                        localStorage.setItem("user-info",JSON.stringify(res.responce));
                        document.location.reload();
                    }
                    else{
                        $('#login_error').empty();
                        $('#login_error').append(res.responce);
                    }
                })

                //var user_id = response.authResponse.userID; //get FB UID
    
                /*FB.api('/me', function(response) {
                    var user_email = response.email; //get user email
                    console.log(user_email)
              // you can store this data into your database           
                });*/
    
            } else {
                //user hit cancel button
                console.log('User cancelled login or did not fully authorize.');
    
            }
        }, {
            scope: 'public_profile,email'
        });
    }
    useEffect(()=>{
        (function() {
            var e = document.createElement('script');
            e.src = document.location.protocol + '//connect.facebook.net/en_US/all.js';
            e.async = true;
            document.getElementById('fb-root').appendChild(e);
        }());
    },[])
  return (
    <>
    <div id='fb-root'></div>
        <div className='social_sign_up_item'>
            <button onClick={fb_login}><ProfileIcon/></button>
        </div>
    </>
  )
}

export default Facebook
